var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.errorResponse != null)?_c('v-alert',{attrs:{"type":"error","outlined":"","dismissible":""}},[_c('h3',[_vm._v("Login error")]),_c('strong',{domProps:{"innerHTML":_vm._s(_vm.errorResponse.status)}}),_vm._v(" "+_vm._s(_vm.errorResponse.data.detail)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }